import { app } from '../../../app';
import { Controller } from './sp-admin.controller';
app.component('companySPAdmin', {
    bindings: {},
    controller: Controller,
    templateUrl: require('./sp-admin.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/sp-admin/sp-admin.component.js